export default "__VITE_ASSET__LMKNJiBW__"